(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Collection-List-Pro"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function Carousel(root) {
    this.root = root;
    this.track = root.querySelector('[data-cl-carousel]');
    if (!this.track) return;
    this.prevBtn = root.querySelector('[data-cl-prev]');
    this.nextBtn = root.querySelector('[data-cl-next]');
    this.dotsWrap = root.querySelector('[data-cl-dots]');
    this.dots = [];
    this.dotCount = -1;
    this.autoplay = this.track.getAttribute('data-autoplay') === 'true';
    this.autoplaySpeed = (parseFloat(this.track.getAttribute('data-autoplay-speed')) || 5) * 1000;
    this.timer = null;
    this.raf = null;
    this.bind();
    this.refresh();

    var self = this;
    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () { self.refresh(); }, { once: true });
    }
  }

  var P = Carousel.prototype;

  P.items = function () {
    return Array.prototype.slice.call(this.track.children);
  };

  P.step = function () {
    var items = this.items();
    if (!items.length) return 1;
    var rect = items[0].getBoundingClientRect();
    var cs = window.getComputedStyle(this.track);
    var gap = parseFloat(cs.columnGap || cs.gap || '0') || 0;
    return rect.width + gap;
  };

  P.perView = function () {
    var step = this.step();
    if (step <= 0) return 1;
    return Math.max(1, Math.round(this.track.clientWidth / step));
  };

  P.scrollable = function () {
    return (this.track.scrollWidth - this.track.clientWidth) > 2;
  };

  P.go = function (dir) {
    var amount = this.step() * this.perView() * dir;
    this.track.scrollBy({ left: amount, behavior: REDUCED.matches ? 'auto' : 'smooth' });
  };

  P.toPage = function (i) {
    var w = this.track.clientWidth;
    this.track.scrollTo({ left: i * w, behavior: REDUCED.matches ? 'auto' : 'smooth' });
  };

  P.pages = function () {
    var w = this.track.clientWidth;
    if (w === 0) return 1;
    return Math.max(1, Math.ceil(this.track.scrollWidth / w));
  };

  P.currentPage = function () {
    var w = this.track.clientWidth;
    if (w === 0) return 0;
    return Math.round(this.track.scrollLeft / w);
  };

  P.buildDots = function () {
    if (!this.dotsWrap) return;
    var count = this.pages();
    if (count === this.dotCount) return;
    this.dotCount = count;
    this.dotsWrap.innerHTML = '';
    this.dots = [];
    if (count <= 1) return;
    var self = this;
    for (var i = 0; i < count; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cl__dot';
      b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      (function (idx) {
        b.addEventListener('click', function () { self.toPage(idx); });
      })(i);
      this.dotsWrap.appendChild(b);
      this.dots.push(b);
    }
  };

  P.update = function () {
    var atStart = this.track.scrollLeft <= 2;
    var atEnd = (this.track.scrollLeft + this.track.clientWidth) >= (this.track.scrollWidth - 2);
    if (this.prevBtn) this.prevBtn.disabled = atStart;
    if (this.nextBtn) this.nextBtn.disabled = atEnd;
    if (this.dots.length) {
      var cur = this.currentPage();
      for (var i = 0; i < this.dots.length; i++) {
        this.dots[i].classList.toggle('is-active', i === cur);
      }
    }
  };

  P.setArrowTop = function () {
    var media = this.root.querySelector('.cl__media');
    if (media) {
      this.root.style.setProperty('--cl-arrow-top', (media.offsetHeight / 2) + 'px');
    }
  };

  P.refresh = function () {
    var on = this.scrollable();
    this.root.classList.toggle('is-scrollable', on);
    this.setArrowTop();
    this.buildDots();
    this.update();
    if (on && this.autoplay) { this.startAuto(); } else { this.stopAuto(); }
  };

  P.onScroll = function () {
    var self = this;
    if (self.raf) return;
    self.raf = window.requestAnimationFrame(function () {
      self.raf = null;
      self.update();
    });
  };

  P.startAuto = function () {
    if (REDUCED.matches || this.timer) return;
    var self = this;
    this.timer = window.setInterval(function () {
      if (!self.scrollable()) return;
      var atEnd = (self.track.scrollLeft + self.track.clientWidth) >= (self.track.scrollWidth - 2);
      if (atEnd) {
        self.track.scrollTo({ left: 0, behavior: REDUCED.matches ? 'auto' : 'smooth' });
      } else {
        self.go(1);
      }
    }, this.autoplaySpeed);
  };

  P.stopAuto = function () {
    if (this.timer) {
      window.clearInterval(this.timer);
      this.timer = null;
    }
  };

  P.bind = function () {
    var self = this;
    if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(-1); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(1); });

    this.track.addEventListener('scroll', function () { self.onScroll(); }, { passive: true });
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.go(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(-1); }
    });

    if (this.autoplay) {
      ['mouseenter', 'focusin', 'pointerdown', 'touchstart'].forEach(function (ev) {
        self.root.addEventListener(ev, function () { self.stopAuto(); }, { passive: true });
      });
      ['mouseleave', 'focusout'].forEach(function (ev) {
        self.root.addEventListener(ev, function () { if (self.scrollable()) self.startAuto(); });
      });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) self.stopAuto();
        else if (self.scrollable()) self.startAuto();
      });
    }

    if ('ResizeObserver' in window) {
      this._ro = new ResizeObserver(function () { self.refresh(); });
      this._ro.observe(this.track);
    } else {
      window.addEventListener('resize', function () { self.refresh(); });
    }
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('.cl-section');
    Array.prototype.forEach.call(roots, function (root) {
      if (!root.querySelector('[data-cl-carousel]')) return;
      if (root.__clInit) return;
      root.__clInit = true;
      new Carousel(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
  document.addEventListener('shopify:section:reorder', function () {
    init(document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
